/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

// ColorPickerCustom.js
import React from "react";
import { HexColorPicker } from "react-colorful";
import { Box, TextField } from "@mui/material";

const ColorPickerCustom = ({ color, onChange }) => {
  return (
    <Box>
      {/* Panel de color con puntero */}
      <Box
        sx={{
          border: "1px solid #ccc",
          borderRadius: "4px",
          mb: 1.5,
          width: "130px", // Más ancho
          height: "80px", // Menor altura
          overflow: "hidden",
          display: "inline-block",
          // Estilos específicos para react-colorful usando selectors anidados
          "& .react-colorful": {
            width: "100%",
            height: "100%",
          },
          "& .react-colorful__saturation": {
            borderRadius: "6px",
          },
          "& .react-colorful__hue": {
            height: "12px", // Línea de selección más delgada
            marginTop: "10px",
            borderRadius: "4px",
          },
          "& .react-colorful__pointer": {
            width: "12px", // Puntero más pequeño
            height: "12px",
            border: "2px solid white",
            boxShadow: "0 0 2px rgba(0,0,0,0.6)",
          },
        }}
      >
        <HexColorPicker color={color} onChange={onChange} />
      </Box>
      {/* Código HEX */}
      <TextField
        label="Código HEX"
        variant="outlined"
        size="small"
        fullWidth
        value={color}
        onChange={(e) => onChange(e.target.value)}
      />
    </Box>
  );
};

export default ColorPickerCustom;
